import { TextBoxShapeUtil } from '../Shapes/TextBoxShape/TextBoxShapeUtil'
import { VisualEditorProps } from './Types'
import {
  Canvas,
  HandTool,
  TLEditorComponents,
  TldrawEditor,
  TldrawHandles,
  TldrawHoveredShapeIndicator,
  TldrawSelectionBackground,
  TldrawUi,
  ZoomTool,
} from '@tldraw/tldraw'
import { Bootstrap } from './Bootstrap/Bootstrap'
import '@tldraw/tldraw/tldraw.css'
import Styles from './VisualEditor.module.scss'
import { ImageShapeUtil } from '../Shapes/ImageShape/ImageShapeUtil'
import { VideoShapeUtil } from '../Shapes/VideoShape/VideoShapeUtil'
import { GeoShapeUtil } from '../Shapes/GeoShape/GeoShapeUtil'
import { FrameShapeUtil } from '../Shapes/FrameShape/FrameShapeUtil'
import { Background } from './components/Background/Background'
import { ContextMenu } from './components/ContextMenu/ContextMenu'
import { DropZone } from './components/DropZone/DropZone'
import { MaskShapeUtil } from '../Shapes/MaskShape/MaskShapeUtil'
import { SelectTool } from '../Tools/SelectTool/SelectTool'
import { SelectionForeground } from './components/SelectionForeground/SelectionForeground'
import { InFrontOfTheCanvas } from './components/InFrontOfTheCanvas/InFrontOfTheCanvas'
import { ErrorFallback } from './components/ErrorFallback/ErrorFallback'
import { observer } from 'mobx-react-lite'
import { DrawerContainer } from './components/DrawerContainer/DrawerContainer'
import { useFinishedRenderingNativeMessage } from 'hooks/useFinishedRenderingNativeMessage'

export const shapeUtils = [
  TextBoxShapeUtil,
  ImageShapeUtil,
  GeoShapeUtil,
  FrameShapeUtil,
  MaskShapeUtil,
  VideoShapeUtil,
]
export const tools = [HandTool, ZoomTool, SelectTool]
export const components: TLEditorComponents = {
  SelectionForeground,
  SelectionBackground: TldrawSelectionBackground,
  Handles: TldrawHandles,
  HoveredShapeIndicator: TldrawHoveredShapeIndicator,
  Background,
  InFrontOfTheCanvas,
  ErrorFallback,
}

const VisualEditor = observer(({ onMount, store }: VisualEditorProps) => {
  useFinishedRenderingNativeMessage()

  return (
    <TldrawEditor
      initialState="select"
      shapeUtils={shapeUtils}
      tools={tools}
      components={components}
      onMount={onMount}
      className={Styles.visualEditor}
      store={store}
    >
      <TldrawUi hideUi>
        <ContextMenu>
          <div>
            <DropZone>
              <Canvas />
            </DropZone>
          </div>
        </ContextMenu>
        <Bootstrap />
        <DrawerContainer />
      </TldrawUi>
    </TldrawEditor>
  )
})

export { VisualEditor }
